/**
 * Created by hp on 2017/6/26.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getJsonFromUrl} from '../../utils';
import axios from 'axios';
import errorImg from '../../images/nodiscount.png'
import kefu1 from '../../images/double-plan-consult1.jpg';
import kefu2 from '../../images/double-plan-consult2.jpg';
import Config from '../../config';
import ChannelSinglePayChannel from './ChannelSinglePayChannel';
import ChannelMonthPayChannel from './ChannelMonthPayChannel';
import ChannelGroupBuyBottomBtn from './ChannelGroupBuyBottomBtn'

import '../../styles/channel/ChannelPayChannel.css';

class ChannelPayChannel extends Component {
    constructor() {
        super();
        this.handleShowGift = this.handleShowGift.bind(this);
        this.handleCheckoutDiscount = this.handleCheckoutDiscount.bind(this);
        this.handleJoinUs = this.handleJoinUs.bind(this);
        this.handlePayDouble = this.handlePayDouble.bind(this);
    }

    handleJoinUs() {
        const {accountId} = this.props;
        let kefu;
        if (accountId % 2) {
            kefu = kefu1;
        } else {
            kefu = kefu2;
        }

        let text = () => {
            return (
                <div>
                    <img src={kefu} alt="客服" />
                    <div>请添加小助手为好友进行报名！</div>
                </div>
            )
        };
        this.context.page.showAlert(text());
    }

    handlePayDouble() {
        const {channelId, discount} = this.props;

        if (discount && discount.price) {
            this.props.dispatch({
                type: 'CHANNEL_SHOW_PAY_PANEL'
            });
        } else {
            this.props.dispatch({
                type: 'PAY_CHANNEL',
                payload: {
                    params: {
                        product: 'pay_channel',
                        channel_id: channelId,
                    },
                    success: () => {
                        window.location = Config.MAIN_URL + `/channel/${channelId}/paysuccess${location.search}`;
                    }
                }
            })
        }
    }

    componentDidMount() {
        let params = getJsonFromUrl();
        if (params.discount_code) {
            this.handleCheckoutDiscount(params.discount_code);
        }
    }

    handleCheckoutDiscount(discountCode) {
        return
    }

    handleShowGift() {
        const {isCostFix} = this.props;
        if (isCostFix) {
            this.props.dispatch({type: 'GIFT_SHOW_DIALOG'})
        } else {
            this.props.dispatch({type: 'CHANNEL_SHOW_MONTH_GIFT_DIALOG'})
        }
    }

    render() {
        const {isCostFix, granted, isRelay, isLiveroomVip, groupBuy, groupBuyAccess, channel} = this.props;
        const isHideGroupBuy = getJsonFromUrl().st === 'channel_cps' || getJsonFromUrl().st === 'hide_group_buy'
        const flag = granted || (isLiveroomVip && !isRelay);

        return (
            <div className={flag ?  "" : "channel-pay-channel weui-flex"} style={{width:'100%'}}>
                {!flag && groupBuy && !isHideGroupBuy && (
                    <ChannelGroupBuyBottomBtn groupBuyAccess={groupBuyAccess} groupBuy={groupBuy} channel={channel} />
                )}
                {!flag && isCostFix && (isHideGroupBuy || !groupBuy) && <ChannelSinglePayChannel />}
                {!flag && !isCostFix && (isHideGroupBuy || !groupBuy) && <ChannelMonthPayChannel />}
            </div>
        )
    }
}

ChannelPayChannel.contextTypes = {
    page: React.PropTypes.object
};

export default connect((state) => ({
    isCostFix: state.channel.channel.is_cost_fix,
    granted: state.channel.channel_access.granted,
    canBuy: state.channel.channel_access.can_buy,
    isRelay: state.channel.channel.is_relay,
    isLiveroomVip: state.channel.role.is_liveroom_vip,
    channelId: state.channel.channel.id,
    accountId: state.account.id,
    discount: state.channel.discount,
    groupBuyAccess: state.channel.groupactivity_access,
    groupBuy: state.channel.groupbuy_info,
    channel: state.channel.channel,
}))(ChannelPayChannel)


// WEBPACK FOOTER //
// ./src/components/channel/ChannelPayChannel.js